const seoFields = `
  seo {
    twitterTitle
    twitterDescription
    twitterImage {
      mediaItemUrl
    }
    opengraphTitle
    opengraphDescription
    opengraphType
    opengraphImage {
      mediaItemUrl
    }
  }
`

export default seoFields
